import { useEffect } from 'react'
import { Layers, Compass, Maximize2, Database } from 'lucide-react'
import { useAppStore } from '../../state/useAppStore'
import Map2D from './Map2D'
import DrilldownUAT from './DrilldownUAT'

const MapContainer = () => {
  const { 
    selectedCounty, 
    drilldownUAT, 
    countiesData,
    uatData,
    loading 
  } = useAppStore()

  useEffect(() => {
    // Log pentru debugging
    if (countiesData) {
      console.log('Counties loaded:', countiesData.features?.length)
    }
    if (uatData) {
      console.log('UATs loaded:', uatData.features?.length)
    }
  }, [countiesData, uatData])

  return (
    <div className="h-full flex flex-col">
      {/* Map Header */}
      <div className="monster-card p-4 mb-4">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="monster-title text-xl font-bold">QUANTUM MAPPER</h2>
            <p className="text-sm text-gray-400">
              {drilldownUAT ? (
                <>
                  <span className="text-monster-cyan">Drilldown Mode</span> • Viewing UATs in {selectedCounty}
                </>
              ) : selectedCounty ? (
                <>
                  <span className="text-monster-cyan">Focus Mode</span> • {selectedCounty} County
                </>
              ) : (
                <>
                  <span className="text-monster-cyan">National Overview</span> • 2D Vector Mode • Real GEOJSON Data
                </>
              )}
            </p>
          </div>
          
          <div className="flex items-center gap-2">
            <button className="p-2 rounded-xl hover:bg-monster-darker/50 transition-all duration-300 group">
              <Layers className="w-5 h-5 text-gray-300 group-hover:text-monster-cyan" />
            </button>
            <button className="p-2 rounded-xl hover:bg-monster-darker/50 transition-all duration-300 group">
              <Compass className="w-5 h-5 text-gray-300 group-hover:text-monster-cyan" />
            </button>
            <button className="p-2 rounded-xl hover:bg-monster-darker/50 transition-all duration-300 group">
              <Maximize2 className="w-5 h-5 text-gray-300 group-hover:text-monster-cyan" />
            </button>
          </div>
        </div>

        {/* Map Status Bar */}
        <div className="mt-4 flex items-center gap-4 text-sm">
          <div className="flex items-center gap-2">
            <div className={`w-2 h-2 rounded-full ${loading ? 'bg-yellow-500' : 'bg-green-500'} animate-pulse`} />
            <span>{loading ? 'Loading Data...' : 'Data Stream Active'}</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-monster-cyan animate-pulse" />
            <span>
              {countiesData ? `${countiesData.features?.length || 0} Counties` : 'Loading counties...'}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-monster-magenta animate-pulse" />
            <span>
              {uatData ? `${uatData.features?.length || 0} UATs` : 'Loading UATs...'}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Database className="w-4 h-4 text-monster-turquoise" />
            <span>Projection: Mercator</span>
          </div>
        </div>
      </div>

      {/* Map Area */}
      <div className="monster-card flex-1 relative overflow-hidden rounded-2xl">
        {drilldownUAT ? (
          <DrilldownUAT />
        ) : (
          <Map2D />
        )}
      </div>

      {/* Map Footer */}
      <div className="mt-4 flex items-center justify-between text-sm text-gray-400">
        <div>
          Data Source: R2 GEOJSON • 
          Projection: WGS84 • 
          Last updated: {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
            <span>Connection: Stable</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-monster-cyan animate-pulse" />
            <span>Render: GPU Accelerated</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MapContainer